module.exports = __webpack_public_path__ + "static/media/tagline.5e8075ef.webp";